module.exports = __webpack_public_path__ + "img/33.c2d30624.jpg";